/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountTerminalApplicationsList } from "../../funcs/accountTerminalApplicationsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAccountTerminalApplicationsRequest$inboundSchema,
};

export const tool$accountTerminalApplicationsList: ToolDefinition<typeof args> =
  {
    name: "account-terminal-applications-list",
    description:
      `Retrieve all terminal applications linked to a specific account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/terminal-applications.read\` scope.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await accountTerminalApplicationsList(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value.result;

      return formatResult(value, apiCall);
    },
  };
